'use strict';
'use es6';

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = buildChatHistory;

var _pipe = require('transmute/pipe');

var _pipe2 = _interopRequireDefault(_pipe);

var _immutable = require('immutable');

var _ChatHistory = require('conversations-schema/records/ChatHistory');

var _ChatHistory2 = _interopRequireDefault(_ChatHistory);

var _PubNubMessageFactory = require('conversations-schema/factories/PubNubMessageFactory');

var _propertyValues = require('conversations-schema/lib/propertyValues');

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _objectWithoutProperties(obj, keys) { var target = {}; for (var i in obj) { if (keys.indexOf(i) >= 0) continue; if (!Object.prototype.hasOwnProperty.call(obj, i)) continue; target[i] = obj[i]; } return target; }

/**
 * Build a ChatHistory record from an JavaScript or Immutable object.
 * 
 * @param {Object|Map|ChatHistory} [props={}] - Properties to build the chat history from
 * @param {Function} [messageFactory=buildPublishedMessage] - Factory function to construct message records
 * @return {ChatHistory}
 *
 */
function buildChatHistory() {
  var _ref = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {},
      _ref$history = _ref.history,
      history = _ref$history === undefined ? [] : _ref$history,
      props = _objectWithoutProperties(_ref, ['history']);

  var messageFactory = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : _PubNubMessageFactory.buildPublishedMessage;

  return (0, _pipe2.default)((0, _propertyValues.setDefaultValues)({ startTime: Date.now() }), (0, _propertyValues.enforceValues)({
    history: (0, _immutable.OrderedSet)(history.map(messageFactory))
  }), _ChatHistory2.default)(props);
}
module.exports = exports['default'];


//////////////////
// WEBPACK FOOTER
// /usr/share/hubspot/build/.hubspot/static-archive/conversations-schema/static-1.79/js/factories/ConversationFactory/buildChatHistory.js
// module id = 300
// module chunks = 0 1